export function useMocks(mockConfig) {
    const { enabled, mockId } = mockConfig;
    return Boolean(enabled && mockId);
}
